import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const SkeletonListItem = styled.li`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.S4};
  margin-bottom: ${Spacing.S4};
  padding: ${Spacing.S8};
`

export const SkeletonDescriptionWrapper = styled.div`
  width: 70%;
`
